import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import LINKS from 'desktop/constants/navigation';
import transportTypes from 'shared/constants/json/transportTypes.json';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
//
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import BrandsSearch from 'desktop/components/BrandsSearch/BrandsSearch';
//
import TypeCatalog from './components/TypeCatalog/TypeCatalog';
import s from './Commercial.css';

class Moto extends React.Component {
  static propTypes = {
    brands: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        count: PropTypes.number,
      }),
    ).isRequired,
    title: PropTypes.string.isRequired,
    routeLocation: PropTypes.shape(),
  };

  static defaultProps = {
    titleLocation: undefined,
    news: [],
    routeLocation: null,
  };
  render() {
    const { brands, routeLocation, title } = this.props;
    const types = LINKS.SEARCH.gruzovye.map(link => ({
      ...link,
      id: (transportTypes.find(type => type.slug === link.route.replace(/\//g, '')) || {}).id,
    }));

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.headerRow}>
            <div className={s.leftHeader}>
              <h1 className={s.mainH1}>{title}</h1>
            </div>
          </div>
          <div className={s.flexContainer}>
            <div className={s.leftCol}>
              <BrandsSearch
                transportSlug={'gruzovye'}
                makes={brands}
                routeLocation={routeLocation}
              />
              <TypeCatalog types={types} />
            </div>
            <DesktopRightSidebar scrollNo>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Moto);



// WEBPACK FOOTER //
// ./src/desktop/routes/commercial/Commercial.js